// extracted by mini-css-extract-plugin
export default {"header":"Layer_header__Y0Rmb"};